import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
import { Select, Space, DatePicker, Button as ModalButton, Modal, TimePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Avatar, Card as LoadingCard, Skeleton, Switch } from 'antd';
const { Meta } = Card;
dayjs.extend(advancedFormat);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;
const dateFormat = "DD/MM/YYYY";
const weekFormat = "w: MMMM YYYY";
const customFormat = (value) => `Semana ${value.format(weekFormat)}`;

const { confirm } = Modal;
const showDeleteConfirm = (hourRange, ctx) => {
  confirm({
    title: '¿Seguro que lo quieres eliminar?',
    icon: <ExclamationCircleFilled />,
    content: 'Esta acción no se podrá deshacer',
    okText: 'Sí',
    okType: 'danger',
    cancelText: 'No',
    onOk() {
      console.log('OK');
      ctx.deleteHourRange(hourRange);
    },
    onCancel() {
      console.log('Cancel');
    },
  });
};

class Schedule extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    let myCompany = null;
    if (this.props.myCompany) {
      myCompany = this.props.myCompany;
    } else {
      myCompany = (this.props.mainState && this.props.mainState.myCompany) ? this.props.mainState.myCompany : null;
    }

    let myCompanyWorkplaces = null;
    if (this.props.myCompanyWorkplaces) {
      myCompanyWorkplaces = this.props.myCompanyWorkplaces;
    } else {
      myCompanyWorkplaces = (myCompany && this.props.mainState.myCompanyWorkplaces && this.props.mainState.myCompanyWorkplaces[myCompany.uuid]) ? this.props.mainState.myCompanyWorkplaces[myCompany.uuid] : null;
    }

    let myEmployees = null;
    if (this.props.myEmployees) {
      myEmployees = this.props.myEmployees;
    } else {
      myEmployees = (myCompany && this.props.mainState.myEmployees && this.props.mainState.myEmployees[myCompany.uuid]) ? this.props.mainState.myEmployees[myCompany.uuid] : null;
    }

    this.state = {
      myCompany: myCompany,
      myCompanyWorkplaces: myCompanyWorkplaces,
      myEmployees: myEmployees,
      servicesSize: "auto",
      shownWeek: dayjs(),
      schedules: []
    };

    this.createSchedulesCard.bind(this);

    this.createMyCompanyCard.bind(this);
    this.createCompanyCardContent(this);
    this.handleMyCompanyFieldChange.bind(this);
    this.handleNewWorkplaceFieldChange.bind(this);
    this.handleEntityFieldChange.bind(this);
    this.loadMyCompany.bind(this);
    this.loadMyCompanyWorkplaces.bind(this);
    this.loadMyCompanyWorkplacesOptions.bind(this);
    this.loadMyEmployees.bind(this);
    this.saveMyCompany.bind(this);
    this.buildWorkplaces.bind(this);
    this.redirectTo.bind(this);
    this.handleEmployeesOptionsChange.bind(this);
    this.handleTemplateOptionsChange.bind(this);
    this.validateAssignSchedule.bind(this);
    this.closeAssignSchedule.bind(this);
    this.getDayHourRangeEditedSchedule = this.getDayHourRangeEditedSchedule.bind(this);
    this.setDayHourRangeEditedSchedule = this.setDayHourRangeEditedSchedule.bind(this);
    this.getEditedScheduleWorkplace = this.getEditedScheduleWorkplace.bind(this);
    this.setEditedScheduleWorkplace = this.setEditedScheduleWorkplace.bind(this);
    this.handleEditScheduleOk = this.handleEditScheduleOk.bind(this);
    this.handleEditScheduleCancel = this.handleEditScheduleCancel.bind(this);
    this.validateEditSchedule = this.validateEditSchedule.bind(this);
    this.saveEmployeeDaySchedule = this.saveEmployeeDaySchedule.bind(this);
    this.getWeekEmployeeHours = this.getWeekEmployeeHours.bind(this);
    this.getDayHours = this.getDayHours.bind(this);
    this.deleteHourRange = this.deleteHourRange.bind(this);

    // let externalUsers = [
    //   "Oniti"
    // ];
    // if (externalUsers.indexOf(this.props.mainState.user.name) > -1) {
    //   this.props.history.push("/clientes");
    // }
  }
  componentDidMount() {
    this.loadMyCompany();
    // this.loadMyEmployees();
  }
  componentWillUnmount() {
    this.props.saveMyCompany(this.state.myCompany);
    this.props.saveMyCompanyWorkplaces(this.state.myCompanyWorkplaces);
    this.props.saveMyEmployees(this.state.myEmployees);
  }
  async loadMyCompany() {
    this.setState({ isLoadingMyCompany: true });
    this.props.loadMyCompany().then(result => {
      this.setState({
        isLoadingMyCompany: false,
        myCompany: result.ok ? result.company : null
      });
      if (result.ok) {
        this.loadMyCompanyWorkplaces(result.company.uuid);
        this.loadMyEmployees(result.company.uuid);
        this.loadSchedules();
      } else {
        this.setState({ myCompanyWorkplaces: [] });
      }
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyCompanyWorkplaces(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyCompanyWorkplaces: true });
    this.props.loadMyCompanyWorkplaces(company_id).then(result => {
      this.setState({
        isLoadingMyCompanyWorkplaces: false,
        myCompanyWorkplaces: result.ok ? result.workplaces : []
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar los centros de trabajo de mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyEmployees(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyEmployees: true });
    this.props.loadMyEmployees(company_id).then(result => {
      this.setState({
        isLoadingMyEmployees: false,
        myEmployees: result.ok ? result.employees : null
      });
      if (!result.ok) {
        this.setState({ myEmployees: [] });
      }
    })
    .catch((error) => {
      this.setState({
        isLoadingMyEmployees: false,
      });
      // Error 😨
      console.log("Error al cargar mis empleados: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveMyCompany() {
    this.setState({
      createCompany: false,
      isSavingMyCompany: true
    });
    this.props.saveMyCompany(this.state.myCompany).then(result => {
      this.setState({
        isSavingMyCompany: false,
        myCompany: result.ok ? result.company : null
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveWorkplace(workplace) {
    this.setState({
      createWorkplace: false,
      editWorkplace: false,
      isSavingWorkplace: true
    });
    workplace = workplace || this.state.newWorkplace;
    workplace.company = this.state.myCompany.uuid;
    workplace = {
      id: workplace.id || null,
      name: workplace.workplaceName,
      street: workplace.workplaceStreet,
      postal_code: workplace.workplacePostalCode,
      locality: workplace.workplaceLocality,
      company: workplace.company
    };
    if (workplace.id) {
      let editingWorkplace = this.state.editingWorkplace;
      if (!editingWorkplace) editingWorkplace = [];
      editingWorkplace[workplace.id] = true;
      this.setState({
        editingWorkplace: editingWorkplace
      });
    } else {
      let workplaces = this.state.myCompanyWorkplaces;
      if (!workplaces) workplaces = [];
      workplace.isNew = true;
      workplaces["new"] = workplace;
    }
    // console.log("saveWorkplace:", workplace);
    // return;
    this.props.saveWorkplace(workplace).then(result => {
      this.setState({
        isSavingWorkplace: false,
        newWorkplace: null
      });
      if (workplace.id) {
        let editingWorkplace = this.state.editingWorkplace;
        if (!editingWorkplace) editingWorkplace = [];
        editingWorkplace[workplace.id] = false;
        this.setState({
          editingWorkplace: editingWorkplace
        });
      }
      this.loadMyCompanyWorkplaces();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveEmployee(employee) {
    this.setState({
      createEmployee: false,
      editEmployee: false,
      isSavingMyEmployee: true
    });
    employee = employee || this.state.newEmployee;
    employee.company = this.state.myCompany.uuid;
    // employee = {
    //   id: employee.id || null,
    //   name: employee.workplaceName,
    //   street: workplace.workplaceStreet,
    //   postal_code: workplace.workplacePostalCode,
    //   locality: workplace.workplaceLocality,
    //   company: workplace.company
    // };
    if (employee.id) {
      let editingEmployee = this.state.editingEmployee;
      if (!editingEmployee) editingEmployee = [];
      editingEmployee[employee.id] = true;
      this.setState({
        editingEmployee: editingEmployee
      });
    } else {
      let employees = this.state.myEmployees;
      if (!employees) employees = [];
      employee.isNew = true;
      employees["new"] = employee;
    }
    // console.log("saveWorkplace:", workplace);
    // return;
    this.props.saveEmployee(employee).then(result => {
      this.setState({
        isSavingMyEmployee: false,
        newEmployee: null
      });
      if (employee.id) {
        let editingEmployee = this.state.editingEmployee;
        if (!editingEmployee) editingEmployee = [];
        editingEmployee[employee.id] = false;
        this.setState({
          editingEmployee: editingEmployee
        });
      }
      this.loadMyEmployees();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empleado: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyEmployeesOptions(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyEmployeesOptions: true });
    this.props.loadMyEmployeesOptions(company_id).then(result => {
      let employees = result.employees;
      this.setState({
        isLoadingMyEmployeesOptions: false,
        employeesOptions: result.ok ? employees : null
      });
      if (!result.ok) {
        this.setState({ employeesOptions: [] });
      }
    })
    .catch((error) => {
      this.setState({
        isLoadingMyEmployeesOptions: false,
      });
      // Error 😨
      console.log("Error al cargar mis empleados para opciones: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyTemplatesOptions(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyTemplates: true });
    this.props.loadMyTemplatesOptions(company_id).then(result => {
      this.setState({
        isLoadingMyTemplates: false,
        myTemplates: result.ok ? result.templates : []
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar las plantillas de horarios de mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyCompanyWorkplacesOptions(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyWorkplaces: true });
    this.props.loadMyCompanyWorkplacesOptions(company_id).then(result => {
      this.setState({
        isLoadingMyWorkplaces: false,
        myWorkplacesOptions: result.ok ? result.workplaces : []
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar los centros de trabajo de mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async assignSchedule(company_id) {
    if (!this.validateAssignSchedule()) {
      console.log("Horario no válido");
      return;
    }
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isAssigningSchedule: true });
    let schedule = {
      employees: this.state.selectedEmployees,
      template: this.state.selectedTemplate,
      workplace: this.state.selectedWorkplace,
      start: this.state.scheduleRange[0].format("YYYY-MM-DD"),
      end: this.state.scheduleRange[1].format("YYYY-MM-DD")
    };
    this.props.assignSchedule(schedule).then(result => {
      console.log("result asignar", result);
      if(result.ok) {
        this.closeAssignSchedule();
        this.loadSchedules();
      }
      this.setState({
        isAssigningSchedule: false
      });
    })
    .catch((error) => {
      this.setState({
        isAssigningSchedule: false
      });
      // Error 😨
      console.log("Error al asignar el horario: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveEmployeeDaySchedule(daySchedule) {
    // let company_id = this.state.myCompany.uuid;
    // this.setState({ isAssigningSchedule: true });
    // let schedule = {
    //   employees: this.state.selectedEmployees,
    //   template: this.state.selectedTemplate,
    //   workplace: this.state.selectedWorkplace,
    //   start: this.state.scheduleRange[0].format("YYYY-MM-DD"),
    //   end: this.state.scheduleRange[1].format("YYYY-MM-DD")
    // };
    this.props.saveEmployeeDaySchedule(daySchedule).then(result => {
      // console.log("result asignar", result);
      // if(result.ok) {
      //   this.closeAssignSchedule();
      //   this.loadSchedules();
      // }
      // this.setState({
      //   isAssigningSchedule: false
      // });
    })
    .catch((error) => {
      // this.setState({
      //   isAssigningSchedule: false
      // });
      // Error 😨
      console.log("Error al asignar el horario del día: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadSchedules(shownWeek) {
    if (!shownWeek) shownWeek = this.state.shownWeek;
    let company_id = this.state.myCompany.uuid;
    let loadingSchedules = this.state.loadingSchedules;
    if (!loadingSchedules) loadingSchedules = [];
    let week = parseInt(shownWeek.format("w"));
    let year = parseInt(shownWeek.format("YYYY"));
    let loadingId = shownWeek.format("w/YYYY");
    if (loadingSchedules[loadingId]) return;
    loadingSchedules[loadingId] = true;
    this.setState({ loadingSchedules: loadingSchedules });
    this.props.loadSchedules(company_id, week, year).then(result => {
      // console.log("Respuesta load schedules", result);
      let loadingSchedules = this.state.loadingSchedules;
      loadingSchedules[loadingId] = false;
      this.setState({
        loadingSchedules: loadingSchedules
      });
      if(result.ok) {
        let schedules = this.state.schedules;
        // console.log("Respuesta ok (schedules)", schedules);
        if (!schedules) schedules = [];
        schedules[loadingId] = result.schedules;
        this.setState({
          loadingSchedules: loadingSchedules,
          schedules: schedules
        });
      }
    })
    .catch((error) => {
      let loadingSchedules = this.state.loadingSchedules;
      loadingSchedules[loadingId] = false;
      this.setState({
        loadingSchedules: loadingSchedules
      });
      // Error 😨
      console.log("Error al cargar las plantillas de horarios de mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  getWeekEmployeeHours(employeeId, suffix, showMinutes) {
    // console.log("week hours", {employeeId, suffix});
    // console.log("this.state.shownWeek", this.state.shownWeek);
    let weekId = this.state.shownWeek.format("w/YYYY");
    let schedules = this.state.schedules[weekId];
    // console.log("schedules", schedules);
    if (!schedules) return;
    let days = Object.keys(schedules);
    let totalHours = 0;
    days.map(dayDate => {
      let day = schedules[dayDate];
      if (day) {
        day = day[employeeId];
        if (day) {
          totalHours += this.getDayHours(day);
        }
      }
    });
    if (showMinutes) {
      let totalMinutes = (totalHours * 60) % 60;
      let stringHours = Math.floor(totalHours) + "h";
      let stringMinutes = totalMinutes + "min";
      let finalString = stringHours;
      if (totalMinutes > 0) {
        finalString = finalString + " " + stringMinutes;
      }
      return finalString;
    } else {
      if (suffix) {
        return totalHours + suffix;
      } else {
        return totalHours;
      }
    }
  }
  getDayHours(weekDay, suffix) {
    let totalHours = 0;
    if (weekDay) {
      let hours = weekDay.hours;
      if (hours && hours.length > 0) {
        hours.map(hour => {
          if (hour.start && hour.end) {
            totalHours += dayjs(hour.end, "HH:mm").diff(
              dayjs(hour.start, "HH:mm"),
              "hour",
              true
            );
          }
        });
      }
    }
    if (suffix) {
      return totalHours + suffix;
    } else {
      return totalHours;
    }
  }
  closeAssignSchedule() {
    this.setState({
      selectedEmployees: [],
      selectedTemplate: null,
      selectedWorkplace: null,
      scheduleRange: null,
      assignSchedule: false
    });
  }
  validateAssignSchedule() {
    let result = true;
    let employees = this.state.selectedEmployees;
    let template = this.state.selectedTemplate;
    let workplace = this.state.selectedWorkplace;
    let range = this.state.scheduleRange;
    // console.log("Validating assign (employees)", employees);
    // console.log("Validating assign (template)", template);
    // console.log("Validating assign (workplace)", workplace);
    // console.log("Validating assign (range)", range);
    if (!employees || employees.length === 0) return false;
    if (!template || template.length === 0) return false;
    if (!workplace || workplace.length === 0) return false;
    if (!range || range.length === 0) return false;
    return result;
  }
  handleMyCompanyFieldChange(field, value) {
    this.handleEntityFieldChange("myCompany", field, value);
    // let myCompany = this.state.myCompany;
    // if (!myCompany) myCompany = {};
    // myCompany[field] = value;
    // this.setState({ myCompany: myCompany });
  }
  handleNewWorkplaceFieldChange(field, value) {
    this.handleEntityFieldChange("newWorkplace", field, value);
    // let newWorkplace = this.state.newWorkplace;
    // if (!newWorkplace) newWorkplace = {};
    // newWorkplace[field] = value;
    // this.setState({ newWorkplace: newWorkplace });
  }
  handleEntityFieldChange(entity_name, field, value) {
    let entity = this.state[entity_name];
    if (!entity) entity = {};
    entity[field] = value;
    this.setState({ [entity_name]: entity });
  }
  handleShownWeekChange(value) {
    let loadingSchedulesId = this.state.shownWeek.format("w/YYYY");
    let newLoadingSchedulesId = value.format("w/YYYY");
    this.setState({ shownWeek: value });
    if (loadingSchedulesId !== newLoadingSchedulesId) this.loadSchedules(value);
  }
  buildWorkplaces() {
    let content = null;
    if (this.state.isLoadingMyCompanyWorkplaces && !this.state.myCompanyWorkplaces) {
      content = (
        <Col xs={12} md={12}>
          <CardTitle><i className="now-ui-icons arrows-1_refresh-69 spin" /></CardTitle>
        </Col>
      );
    } else {
      if (this.state.createWorkplace || this.state.editWorkplace) {
        let newWorkplace = this.state.newWorkplace;
        if(!newWorkplace) newWorkplace = {}; 
        let workplaceName = (newWorkplace && newWorkplace.workplaceName) ? newWorkplace.workplaceName : "";
        let workplaceStreet = (newWorkplace && newWorkplace.workplaceStreet) ? newWorkplace.workplaceStreet : "";
        let workplaceLocality = (newWorkplace && newWorkplace.workplaceLocality) ? newWorkplace.workplaceLocality : "";
        let workplacePostalCode = (newWorkplace && newWorkplace.workplacePostalCode) ? newWorkplace.workplacePostalCode : "";
        content = (
          <Row className="text-left workplace-info new-workplace">
            <Col xs={12} md={12}>
              <CardHeader>
                <b>
                  {newWorkplace.isNew ? (<span><i className="now-ui-icons ui-1_simple-add" /> Nuevo centro</span>) : (<span><i className="fa fa-edit" /> Editar centro</span>)}
                </b>
              </CardHeader>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Nombre</Label>
              <FormGroup>
                <Input
                  type="text"
                  name="workplaceName"
                  placeholder="Oficina central"
                  value={workplaceName}
                  onChange={event =>
                    this.handleNewWorkplaceFieldChange("workplaceName", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Calle</Label>
              <FormGroup>
                <Input
                  type="text"
                  name="workplaceStreet"
                  placeholder="Paseo Delicias 24"
                  value={workplaceStreet}
                  onChange={event =>
                    this.handleNewWorkplaceFieldChange("workplaceStreet", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Localidad</Label>
              <FormGroup>
                <Input
                  type="text"
                  name="workplaceLocality"
                  placeholder="Madrid"
                  value={workplaceLocality}
                  onChange={event =>
                    this.handleNewWorkplaceFieldChange("workplaceLocality", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Código postal</Label>
              <FormGroup>
                <Input
                  type="number"
                  name="workplacePostalCode"
                  placeholder="28014"
                  value={workplacePostalCode}
                  onChange={event =>
                    this.handleNewWorkplaceFieldChange("workplacePostalCode", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={6}>
              <Button 
                block 
                color="success" 
                size="sm"
                onClick={() => {
                  this.saveWorkplace();
                  // this.setState({ createCompany: false });
                }}
                >
                Guardar
              </Button>
            </Col>
            <Col xs={6}>
              <Button 
                block 
                color="default" 
                size="sm"
                onClick={() => {
                  this.setState({
                    createWorkplace: false,
                    newWorkplace: null,
                    editWorkplace: null
                  });
                }}
                >
                Cancelar
              </Button>
            </Col>
          </Row>
        );
      } else {
        if (this.state.myCompanyWorkplaces && Object.keys(this.state.myCompanyWorkplaces).length > 0) {
          let workplaces = [];
          let workplacesIds = Object.keys(this.state.myCompanyWorkplaces);
          let size = workplacesIds.length;
          if (size > 2) {
            size = {
              xs: 12,
              md: 4,
              lg: 3,
              xl: 2
            };
          }
          workplacesIds.map(workplaceId => {
            let workplace = this.state.myCompanyWorkplaces[workplaceId];
            let bodyContent = null;
            let specialColor = false;
            if (workplace.isNew) {
              bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Creando</span>;
              specialColor = true;
            } else if (this.state.editingWorkplace && this.state.editingWorkplace[workplaceId]) {
              bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Guardando</span>;
              specialColor = true;
            } else {
              bodyContent = workplace.street + ", " + workplace.locality + " (" + workplace.postal_code + ")";
            }
            let options = null;
            if (this.state.openOptions === workplaceId) {
              bodyContent = (
                <Row id="edit-workplace-buttons">
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          editWorkplace: workplace.id,
                          openOptions: null,
                          newWorkplace: {
                            id: workplace.id,
                            workplaceName: workplace.name,
                            workplaceStreet: workplace.street,
                            workplaceLocality: workplace.locality,
                            workplacePostalCode: workplace.postal_code
                          }
                        });
                      }}
                      color="primary"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isSavingMyCompany}
                    >
                      <i className="fa fa-edit" /> Editar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          openOptions: null
                        });
                      }}
                      color="danger"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isSavingMyCompany}
                    >
                      <i className="fa fa-trash" /> Eliminar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                </Row>
              );
              // options = (
              //   <div className="corner-action-icon delete-workplace">
              //     <Button
              //       onClick={() => {
              //         this.setState({
              //           editWorkplace: workplace.id,
              //           newWorkplace: {
              //             id: workplace.id,
              //             workplaceName: workplace.name,
              //             workplaceStreet: workplace.street,
              //             workplaceLocality: workplace.locality,
              //             workplacePostalCode: workplace.postal_code
              //           }
              //         });
              //       }}
              //       color="primary"
              //       size="sm"
              //       round
              //       icon
              //       disabled={this.state.isSavingMyCompany}
              //     >
              //       <i className="fa fa-edit" />
              //       {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
              //     </Button>
              //     <Button
              //       // onClick={() => {
              //       //   this.setState({
              //       //     newWorkplace: null,
              //       //     createWorkplace: true
              //       //   });
              //       // }}
              //       color="primary"
              //       size="sm"
              //       round
              //       icon
              //       disabled={this.state.isSavingMyCompany}
              //     >
              //       <i className="fa fa-trash" />
              //       {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
              //     </Button>
              //   </div>
              // );
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptions: null
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="now-ui-icons ui-1_simple-remove" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            } else {
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptions: workplace.id
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="fa fa-ellipsis-v" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            }
            workplaces.push(
              <Col {...size} key={workplace.id}>
                <Card className={"workplace-info card-stats plain " + (specialColor ? "workplace-editing" : "")}>
                  <CardHeader>
                    <b>
                      <i className="fa fa-building" /> {workplace.name}
                    </b>
                    {options}
                  </CardHeader>
                    <CardBody>{bodyContent}</CardBody>
                </Card>
              </Col>
            );
          });
          content = <Row>{workplaces}</Row>;
        } else {
          content = (
            <Row>
              <Col xs={12} md={12}>
                No hay centros
                <Button 
                  block 
                  color="primary" 
                  size="sm"
                  disabled={this.state.isSavingWorkplace}
                  onClick={() => {
                    this.setState({
                      newWorkplace: {
                        isNew: true
                      },
                      createWorkplace: true
                    });
                  }}
                  >
                  {!this.state.isSavingWorkplace ?
                    (<span><i className="now-ui-icons ui-1_simple-add" /> Añadir centro</span>) :
                    (<span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Añadiendo</span>)
                  }
                </Button>
              </Col>
            </Row>
          );
        }
      }
    }
    let card = (
      <Col xs={12}>
        <Card className="my-company-workplaces-info card-stats plain">
          <CardHeader>
            <b>
              <i className="fa fa-building" /> Centros de trabajo
            </b>
            {(this.state.myCompanyWorkplaces && !this.state.createWorkplace) && <div className="corner-action-icon">
                <Button
                  onClick={() => {
                    this.setState({
                      newWorkplace: { isNew: true },
                      createWorkplace: true
                    });
                  }}
                  color="primary"
                  size="sm"
                  round
                  // icon
                  disabled={this.state.isSavingMyCompany}
                >
                  <i className="now-ui-icons ui-1_simple-add" /> Nuevo
                  {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                </Button>
              </div>
            }
          </CardHeader>
          <CardBody>
            {content}
          </CardBody>
        </Card>
      </Col>
    );
    return card;
  }
  createCompanyCardContent() {
    let content = null;
    if (this.state.isLoadingMyCompany && !this.state.myCompany) {
      content = (
        <Row className="text-center">
          <Col xs={12} md={12}>
            <CardTitle><i className="now-ui-icons arrows-1_refresh-69 spin" /></CardTitle>
          </Col>
        </Row>
      );
    } else if (this.state.createCompany) {
      let companyNif = (this.state.myCompany && this.state.myCompany.nif) ? this.state.myCompany.nif : "";
      let companyName = (this.state.myCompany && this.state.myCompany.name) ? this.state.myCompany.name : "";
      content = (
        <Row className="text-left">
          <Col xs={12} md={12}>
            <Label md={3}>NIF</Label>
            <FormGroup>
              <Input
                type="text"
                name="companyNIF"
                placeholder="NIF de la empresa"
                value={companyNif}
                onChange={event =>
                  this.handleMyCompanyFieldChange("nif", event.target.value)
                }
              />
            </FormGroup>
          </Col>
          <Col xs={12} md={12}>
            <Label md={3}>Nombre legal</Label>
            <FormGroup>
              <Input
                type="text"
                name="companyName"
                placeholder="Empresa SL"
                value={companyName}
                onChange={event =>
                  this.handleMyCompanyFieldChange("name", event.target.value)
                }
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <Button 
              block 
              color="success" 
              size="sm"
              onClick={() => {
                this.saveMyCompany();
                // this.setState({ createCompany: false });
              }}
              >
              Guardar
            </Button>
          </Col>
          <Col xs={6}>
            <Button 
              block 
              color="default" 
              size="sm"
              onClick={() => {
                this.setState({
                  createCompany: false,
                  myCompany: JSON.parse(this.state.myCompanyBefore)
                });
              }}
              >
              Cancelar
            </Button>
          </Col>
        </Row>
      );
    } else if (!this.state.myCompany) {
      content = (
        <Row className="text-center">
          <Col xs={12} md={12}>
            No hay información
          </Col>
          <Col xs={12} md={12}>
            <Button 
              block 
              color="primary" 
              size="sm"
              onClick={() => {
                this.setState({
                  myCompanyBefore: JSON.stringify(this.state.myCompany),
                  createCompany: true
                });
              }}
              >
              <i className="now-ui-icons ui-1_simple-add" /> Añadir empresa
            </Button>
          </Col>
        </Row>
      );
    } else {
      content = (
        <Row className="text-center">
          <Col xs={12} md={12}>
            <CardTitle>{this.state.myCompany.name}</CardTitle>
          </Col>
          <Col xs={12} md={12}>
            {this.state.myCompany.nif}
          </Col>
          {this.buildWorkplaces()}
        </Row>
      );
    }
    return content;
  }
  createMyCompanyCard() {
    let card = null;
    let content = this.createCompanyCardContent();

    card = (
      <Col xs={12}>
        <Card id="my-company-info" className="card-stats card-raised">
          <CardHeader>
            <b><i className="fa fa-university"></i> Mi empresa</b>
            {(this.state.myCompany && !this.state.createCompany) && <div className="corner-action-icon">
              <Button
                onClick={() => {
                  this.setState({
                    myCompanyBefore: JSON.stringify(this.state.myCompany),
                    createCompany: true
                  });
                }}
                color="primary"
                size="sm"
                round
                // icon
                disabled={this.state.isSavingMyCompany}
              >
                <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> Editar
              </Button>
            </div>}
          </CardHeader>
          <CardBody>
            {content}
          </CardBody>
        </Card>
      </Col>
    );
    return card;
  }
  createEmployeesCardContent() {
    let content = null;
    if (this.state.isLoadingMyEmployees && !this.state.myEmployees) {
      content = (
        <Col xs={12} md={12}>
          <CardTitle><i className="now-ui-icons arrows-1_refresh-69 spin" /></CardTitle>
        </Col>
      );
    } else {
      if (this.state.createEmployee || this.state.editEmployee) {
        let newEmployee = this.state.newEmployee;
        if (!newEmployee) newEmployee = {};
        let fields = [
          {
            title: "Nombre",
            name: "name",
            type: "text",
            placeholder: "María"
          },
          {
            title: "Primer apellido",
            name: "surname1",
            type: "text",
            placeholder: "García"
          },
          {
            title: "Segundo apellido",
            name: "surname2",
            type: "text",
            placeholder: "Pérez"
          },
          {
            title: "Email",
            name: "email",
            type: "email",
            placeholder: "correo@dominio.es"
          },
          {
            title: "Móvil",
            name: "mobile",
            type: "number",
            placeholder: "612345678"
          }
        ];
        // let name = (newEmployee && newEmployee.name) ? newEmployee.name : "";
        // let surname1 = (newEmployee && newEmployee.surname1) ? newEmployee.surname1 : "";
        // let surname2 = (newEmployee && newEmployee.surname1) ? newEmployee.surname1 : "";
        // let email = (newEmployee && newEmployee.email) ? newEmployee.email : "";
        // let mobile = (newEmployee && newEmployee.mobile) ? newEmployee.mobile : "";
        console.log(this.state);
        content = (
          <Row className="text-left employee-info new-employee">
            <Col xs={12} md={12}>
              <CardHeader>
                <b>
                  {newEmployee.isNew ? (<span><i className="now-ui-icons ui-1_simple-add" /> Nuevo empleado</span>) : (<span><i className="fa fa-edit" /> Editar empleado</span>)}
                </b>
              </CardHeader>
            </Col>
            {fields.map(field => {
              field.value = this.state.newEmployee && this.state.newEmployee[field.name] ? this.state.newEmployee[field.name] : "";
              return (
                <Col xs={12} md={12} key={"new-employee-" + field.name}>
                  <Label md={3}>{field.title}</Label>
                  <FormGroup>
                    <Input
                      {...field}
                      onChange={event =>
                        this.handleEntityFieldChange("newEmployee", field.name, event.target.value)
                      }
                    />
                  </FormGroup>
                </Col>
              );
            })}
            <Col xs={6}>
              <Button 
                block 
                color="success" 
                size="sm"
                onClick={() => {
                  this.saveEmployee();
                  // this.setState({ createCompany: false });
                }}
                >
                Guardar
              </Button>
            </Col>
            <Col xs={6}>
              <Button 
                block 
                color="default" 
                size="sm"
                onClick={() => {
                  this.setState({
                    createEmployee: false,
                    newEmployee: null,
                    editEmployee: null
                  });
                }}
                >
                Cancelar
              </Button>
            </Col>
          </Row>
        );
      } else {
        if (this.state.myEmployees && Object.keys(this.state.myEmployees).length > 0) {
          let weekId = this.state.shownWeek.format("w/YYYY");
          let employees = [];
          // console.log("this.state.schedules",this.state.schedules);
          let employeesIds = Object.keys(this.state.myEmployees);
          let size = employeesIds.length;
          // if (size > 2) {
            size = {
              xs: 12,
              md: 4,
              lg: 3,
              xl: 2
            };
          // }
          employeesIds.map(employeeId => {
            let employee = this.state.myEmployees[employeeId];
            let bodyContent = null;
            let specialColor = false;
            if (employee.isNew) {
              bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Creando</span>;
              specialColor = true;
            } else if (this.state.editingEmployee && this.state.editingEmployee[employeeId]) {
              bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Guardando</span>;
              specialColor = true;
            } else {
              bodyContent = employee.mobile + " · " + employee.email;
            }
            let options = null;
            if (this.state.openOptionsEmployee === employeeId) {
              bodyContent = (
                <Row id="edit-workplace-buttons">
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          editEmployee: employeeId,
                          openOptionsEmployee: null,
                          newEmployee: employee
                        });
                      }}
                      color="primary"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isSavingMyEmployee}
                    >
                      <i className="fa fa-edit" /> Editar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          openOptionsEmployee: null
                        });
                      }}
                      color="danger"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isSavingMyEmployee}
                    >
                      <i className="fa fa-trash" /> Eliminar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                </Row>
              );
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptionsEmployee: null
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="now-ui-icons ui-1_simple-remove" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            } else {
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptionsEmployee: employeeId
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="fa fa-ellipsis-v" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            }
            let employeeSchedule = [];
            if (weekId in this.state.schedules) {
              // console.log("days", Object.keys(this.state.schedules[weekId]));
              Object.keys(this.state.schedules[weekId]).map(day => {
                // console.log("current day", day);
                let schedule = this.state.schedules[weekId][day];
                // console.log("schedule", schedule);
                // console.log("employeeId", employeeId);
                if (schedule[employeeId]) {
                  let employeeHours = schedule[employeeId].hours;
                  // console.log("employeeHours", employeeHours);
                  if (employeeHours && employeeHours.length > 0) {
                    let currentEmployeeHours = [];
                    employeeHours.map((hour) => {
                      // console.log("hour", hour);
                      let subHour = [];
                      subHour.push(
                        <div key={"mini-range-" + hour.number} className="range-wrapper">
                          <Row className="row-range-wrapper">
                            <Col xs={6} className="schedule-hour start-hour">{hour.start}</Col>
                            <Col xs={6} className="schedule-hour end-hour">{hour.end}</Col>
                          </Row>
                        </div>
                      );
                      if (hour.workplace) subHour.push(<div key={"mini-range-workplace-" + hour.number} className="schedule-workplace"><span><i className="fa fa-building"></i> {hour.workplace.name}</span></div>);
                      currentEmployeeHours.push(
                        <div key={"hour-wrapper-" + hour.number} className="schedule-hour-wrapper">
                          {subHour}
                          <Row className="row-range-actions">
                            <Col xs={6} className="schedule-hour-edit text-center">
                              <Button
                                block
                                onClick={() => {
                                  this.loadMyCompanyWorkplacesOptions();
                                  this.setState({
                                    openEditSchedule: true,
                                    editedSchedule: {
                                      start: hour.start,
                                      end: hour.end,
                                      hourNumber: hour.number,
                                      workplace: hour.workplace,
                                      weekId: weekId,
                                      employeeId: employeeId,
                                      dayId: day
                                    }
                                  });
                                  // this.setState({
                                  //   editWorkplace: workplace.id,
                                  //   newWorkplace: {
                                  //     id: workplace.id,
                                  //     workplaceName: workplace.name,
                                  //     workplaceStreet: workplace.street,
                                  //     workplaceLocality: workplace.locality,
                                  //     workplacePostalCode: workplace.postal_code
                                  //   }
                                  // });
                                }}
                                color="primary"
                                size="xl"
                                // round
                                // icon
                                // disabled={this.state.isSavingMyCompany}
                              >
                                <i className="fa fa-edit" />
                                {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                              </Button>
                            </Col>
                            <Col xs={6} className="schedule-hour-delete text-center">
                              <Button
                                block
                                onClick={() => showDeleteConfirm({
                                  start: hour.start,
                                  end: hour.end,
                                  hourNumber: hour.number,
                                  workplace: hour.workplace,
                                  weekId: weekId,
                                  employeeId: employeeId,
                                  dayId: day
                                }, this)}
                                color="danger"
                                size="xl"
                                // round
                                // icon
                                // disabled={this.state.isSavingMyCompany}
                              >
                                <i className="fa fa-trash" />
                                {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      );
                      //   <td key={"employee-schedule-" + hour.number + "-" + employeeId}>
                      //     <div className="schedule-hour-wrapper">
                      //       <div><span className="schedule-hour">{hour.start}</span><span className="schedule-hour">{hour.end}</span></div>
                      //       {hour.workplace && <div className="schedule-workplace"><span><i className="fa fa-building"></i> {hour.workplace.name}</span></div>}
                      //     </div>
                      //   </td>
                      // );
                    });
                    employeeSchedule.push(<td className={dayjs().format("YYYY/MM/DD") === dayjs(day).format("YYYY/MM/DD") ? "schedule-active-day": ""} key={"employee-schedule-hours-" + day + "-" + employeeId}>{currentEmployeeHours}</td>);
                  } else {
                    employeeSchedule.push(<td className={dayjs().format("YYYY/MM/DD") === dayjs(day).format("YYYY/MM/DD") ? "schedule-active-day": ""} key={"employee-schedule-hours-empty" + day + "-" + employeeId}></td>);
                  }
                }
              });
            }
            // console.log("employeeSchedule", employeeSchedule);
            let weekHours = this.getWeekEmployeeHours(employeeId);
            let weekHoursString = "";
            let hoursClassName = "week-hours-ok";
            if (weekHours !== Math.floor(weekHours)){
              weekHoursString = this.getWeekEmployeeHours(employeeId, "h", true);
            } else {
              weekHoursString = weekHours + "h";
            }
            if (weekHours < 40) {
              hoursClassName = "week-hours-warning";
            } else if (weekHours > 40) {
              hoursClassName = "week-hours-danger";
            }
            employees.push(
              <tr className="schedule-row" {...size} key={employeeId}>
                <td className="td-schedule-worker">
                  <div className="schedule-worker">
                    <div className="employee-initials">{employee.name[0]}{employee.surname1[0]}</div>
                    <b>
                      <i className="fa fa-child" /> {employee.name}{" "}{employee.surname1}
                    </b><br />
                    <span className={"week-hours " + hoursClassName}>{weekHoursString}</span>
                  </div>
                </td>
                {employeeSchedule}
                {/* <td>
                  <div className="schedule-hour-wrapper">
                    <div><span className="schedule-hour">09:00</span><span className="schedule-hour">14:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                    <div className="secondHour"><span className="schedule-hour">16:00</span><span className="schedule-hour">19:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                  </div>
                </td>
                <td>
                  <div className="schedule-hour-wrapper">
                    <div><span className="schedule-hour">09:00</span><span className="schedule-hour">14:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                    <div className="secondHour"><span className="schedule-hour">16:00</span><span className="schedule-hour">19:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                  </div>
                </td>
                <td>
                  <div className="schedule-hour-wrapper">
                    <div><span className="schedule-hour">09:00</span><span className="schedule-hour">14:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                    <div className="secondHour"><span className="schedule-hour">16:00</span><span className="schedule-hour">19:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                  </div>
                </td>
                <td>
                  <div className="schedule-hour-wrapper">
                    <div><span className="schedule-hour">09:00</span><span className="schedule-hour">14:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                    <div className="secondHour"><span className="schedule-hour">16:00</span><span className="schedule-hour">19:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                  </div>
                </td>
                <td>
                  <div className="schedule-hour-wrapper">
                    <div><span className="schedule-hour">09:00</span><span className="schedule-hour">14:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                    <div className="secondHour"><span className="schedule-hour">16:00</span><span className="schedule-hour">19:00</span></div>
                    <div className="schedule-workplace"><span><i className="fa fa-building"></i> Oficina Bétera</span></div>
                  </div>
                </td>
                <td>
                </td>
                <td>
                </td> */}
              </tr>
            );
          });
          content = (
            <Row>
              <Col className="text-center" xs={12}>
                <DatePicker
                  picker="week"
                  bordered={false}
                  defaultValue={dayjs()}
                  format={customFormat}
                  value={this.state.shownWeek}
                  onChange={value => this.handleShownWeekChange(value)}
                  allowClear={false}
                />
              </Col>
              <Col>
              {!(weekId in this.state.schedules) && 
                <LoadingCard style={{ width: "100%", marginTop: 16 }} loading={true}>
                  <Meta
                    avatar={<Avatar src="https://joeschmoe.io/api/v1/random" />}
                    title="Horario de la semana"
                    description=""
                  />
                </LoadingCard>}
                {(weekId in this.state.schedules) && <Table responsive className="styled-table">
                  <thead>
                    <tr className="text-primary">
                      <th>Empleado</th>
                      {Object.keys(this.state.schedules[weekId]).map(day => {
                        return <th key={"day-" + day} className={dayjs().format("YYYY/MM/DD") === dayjs(day).format("YYYY/MM/DD") ? "schedule-active-day": ""}>{dayjs(day).format("ddd D")}</th>
                      })}
                      {/* <th>Lun. 24</th>
                      <th className="schedule-active-day"><b>Mar. 25</b></th>
                      <th>Mié. 26</th>
                      <th>Jue. 27</th>
                      <th>Vie. 28</th>
                      <th>Sáb. 29</th>
                      <th>Dom. 30</th> */}
                    </tr>
                  </thead>
                  <tbody>{employees}</tbody>
                </Table>}
              </Col>
            </Row>
          );
        } else {
          content = (
            <Row>
              <Col xs={12} md={12}>
                No hay empleados
                <Button 
                  block 
                  color="primary" 
                  size="sm"
                  disabled={this.state.isSavingMyEmployee}
                  onClick={() => {
                    this.setState({
                      newEmployee: {
                        isNew: true
                      },
                      createEmployee: true
                    });
                  }}
                  >
                  {!this.state.isSavingMyEmployee ?
                    (<span><i className="now-ui-icons ui-1_simple-add" /> Añadir empleado</span>) :
                    (<span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Añadiendo</span>)
                  }
                </Button>
              </Col>
            </Row>
          );
        }
      }
    }
    return content;
    let card = (
      <Col xs={12}>
        <Card className="my-company-workplaces-info card-stats plain">
          <CardHeader>
            <b>
              <i className="fa fa-building" /> Centros de trabajo
            </b>
            <div className="corner-action-icon">
              <Button
                onClick={() => {
                  this.setState({
                    newWorkplace: null,
                    createWorkplace: true
                  });
                }}
                color="primary"
                size="sm"
                round
                // icon
                disabled={this.state.isSavingMyCompany}
              >
                <i className="now-ui-icons ui-1_simple-add" /> Nuevo
                {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            {content}
          </CardBody>
        </Card>
      </Col>
    );
    return card;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  handleEmployeesOptionsChange(value) {
    this.setState({ selectedEmployees: value });
  }
  handleTemplateOptionsChange(value) {
    this.setState({ selectedTemplate: value });
  }
  handleWorkplaceOptionsChange(value) {
    this.setState({ selectedWorkplace: value });
  }
  createAssignSchedule() {
    let result = null;
    let fieldSizes = {
      xs: 12,
      md: 6,
      xl: 4,
      style: { marginBottom: "5px" }
    };
    result = (
      <Row>
        <Col>
          <Card className="assign-schedule">
            <CardHeader>
              <h5>
                <i className="now-ui-icons ui-1_simple-add" /> Asignar horario
              </h5>
            </CardHeader>
            <CardBody>
              <FormGroup>
                <Row>
                  <Col {...fieldSizes}>
                    <Select
                      mode="multiple"
                      allowClear
                      style={{
                        width: "100%"
                      }}
                      status={this.state.employeesOptions ? null : "error"}
                      loading={!this.state.employeesOptions}
                      placeholder="Selecciona empleados"
                      value={this.state.selectedEmployees}
                      // defaultValue={['a10', 'c12']}
                      onChange={value => this.handleEmployeesOptionsChange(value)}
                      options={this.state.employeesOptions}
                      suffixIcon={<i className="fa fa-users" />}
                      showArrow
                      filterOption={(inputValue, option) =>
                        option.label
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }
                      size="large"
                      disabled={this.state.isAssigningSchedule}
                    />
                  </Col>
                  <Col {...fieldSizes}>
                    <Select
                      // mode="multiple"
                      allowClear
                      style={{
                        width: "100%"
                      }}
                      loading={!this.state.myTemplates}
                      placeholder="Elige la plantilla"
                      value={this.state.selectedTemplate}
                      // defaultValue={['a10', 'c12']}
                      onChange={value => this.handleTemplateOptionsChange(value)}
                      options={this.state.myTemplates}
                      suffixIcon={<i className="now-ui-icons design_bullet-list-67" />}
                      size="large"
                      disabled={this.state.isAssigningSchedule}
                    />
                  </Col>
                  <Col {...fieldSizes}>
                    <Select
                      // mode="multiple"
                      allowClear
                      style={{
                        width: "100%"
                      }}
                      loading={!this.state.myWorkplacesOptions}
                      placeholder="Elige el lugar"
                      value={this.state.selectedWorkplace}
                      // defaultValue={['a10', 'c12']}
                      onChange={value => this.handleWorkplaceOptionsChange(value)}
                      options={this.state.myWorkplacesOptions}
                      suffixIcon={<i className="fa fa-building" />}
                      size="large"
                      disabled={this.state.isAssigningSchedule}
                    />
                  </Col>
                  <Col {...fieldSizes}>
                    <RangePicker
                      onChange={value => {
                        this.setState({ scheduleRange: value });
                        // console.log("cambio del picker range", value);
                        // this.setScheduleRange(value);
                      }}
                      status={this.state.scheduleRange ? null : "error"}
                      format={dateFormat}
                      value={this.state.scheduleRange}
                      defaultOpenValue={dayjs()}
                      size="large"
                      style={{ width: "100%" }}
                      disabled={this.state.isAssigningSchedule}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6}>
                    <Button
                      block
                      color="success"
                      size="lg"
                      disabled={!this.validateAssignSchedule() || this.state.isAssigningSchedule}
                      onClick={() => {
                        this.assignSchedule();
                        // this.saveWorkplace();
                        // this.setState({ createCompany: false });
                      }}
                    >
                      {this.state.isAssigningSchedule ? <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Asignando</span> : "Asignar"}
                    </Button>
                  </Col>
                  <Col xs={12} md={6}>
                    <Button
                      block
                      color="default"
                      size="lg"
                      onClick={() => {
                        // this.saveWorkplace();
                        this.closeAssignSchedule();
                      }}
                    >
                      Cancelar
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
    return result;
  }
  createSchedulesCard() {
    let card = null;
    let content = this.createEmployeesCardContent();
    let assignSchedule = this.state.assignSchedule ? this.createAssignSchedule() : null;

    card = (
      <Col xs={12}>
        <Card id="my-employees-info" className="card-stats card-raised">
          <CardHeader>
            <h3>
              <span style={{ display: "block" }}>
                <b>
                  <i className="now-ui-icons ui-1_calendar-60"></i> Control de
                  turnos
                </b>
              <Button
                onClick={() => {
                  this.redirectTo("/turnos/plantillas");
                  // this.setState({
                  //   newEmployee:  { isNew: true },
                  //   createEmployee: true
                  // });
                }}
                color="primary"
                size="sm"
                round
                style={{ float: "right",margin: 0 }}
                // icon
                // disabled={this.state.isSavingMyEmployee}
              >
                <i className="now-ui-icons design_bullet-list-67" /> Plantillas
              </Button>
              <Button
                disabled={this.state.assignSchedule}
                onClick={() => {
                  this.loadMyEmployeesOptions();
                  this.loadMyTemplatesOptions();
                  this.loadMyCompanyWorkplacesOptions();
                  this.setState({ assignSchedule: true });
                  // this.setState({
                  //   newEmployee:  { isNew: true },
                  //   createEmployee: true
                  // });
                }}
                color="primary"
                size="sm"
                round
                style={{ float: "right",margin: 0 }}
                // icon
                // disabled={this.state.isSavingMyEmployee}
              >
                <i className="now-ui-icons ui-1_simple-add" /> Asignar horario
              </Button>
              </span>
            </h3>
          </CardHeader>
          <CardBody>
            {assignSchedule}
            {content}
          </CardBody>
        </Card>
      </Col>
    );
    return card;
  }
  getDayHourRangeEditedSchedule() {
    let hour = this.state.editedSchedule;
    if (!hour) return null;
    if (!hour.start || !hour.end) return null;
    let range = [dayjs(hour.start, "HH:mm"), dayjs(hour.end, "HH:mm")];
    return range;
  }
  setDayHourRangeEditedSchedule(value) {
    if (!value) return;
    let editedSchedule = this.state.editedSchedule;
    editedSchedule.start = value[0].format("HH:mm");
    editedSchedule.end = value[1].format("HH:mm");
    // let newHour = {
    //   start: null,
    //   end: null,
    //   number: number
    // };
    this.setState({ editedSchedule: editedSchedule });
    return;
  }
  getEditedScheduleWorkplace() {
    let editedSchedule = this.state.editedSchedule;
    if (!editedSchedule) return null;
    let workplace = editedSchedule.workplace;
    console.log("set edited (editedSchedule)", editedSchedule);
    console.log("set edited (workplace)", workplace);
    if (!workplace) return null;
    return {
      value: workplace.id,
      label: workplace.name
    };
  }
  setEditedScheduleWorkplace(value) {
    let editedSchedule = this.state.editedSchedule;
    console.log("set edited (value)", value);
    console.log("set edited (editedSchedule)", editedSchedule);
    let selectedOption = null;
    this.state.myWorkplacesOptions.map(option => {
      if (option.value === value) selectedOption = option;
    });
    editedSchedule.workplace = {
      id: selectedOption.value,
      name: selectedOption.label
    };
    this.setState({ editedSchedule: editedSchedule });
  }
  handleEditScheduleOk() {
    let editedSchedule = this.state.editedSchedule;
    let employeeId = editedSchedule.employeeId;
    let dayId = editedSchedule.dayId;
    let hourNumber = editedSchedule.hourNumber;
    let weekId = editedSchedule.weekId;
    let schedules = this.state.schedules;
    let weekSchedule = schedules[weekId];
    let daySchedules = weekSchedule[dayId];
    let day = daySchedules[employeeId];
    let hours = day.hours;
    let newHour = {
      start: editedSchedule.start,
      end: editedSchedule.end,
      number: hourNumber,
      workplace: editedSchedule.workplace
    };
    let newHours = [];
    hours.map(_hour => {
      if (_hour.number === hourNumber) _hour = newHour;
      newHours.push(_hour);
    });
    day.hours = newHours;
    daySchedules[employeeId] = day;
    weekSchedule[dayId] = daySchedules;
    schedules[weekId] = weekSchedule;
    this.setState({
      schedules: schedules,
      openEditSchedule: false,
      editedSchedule: null
    });
    let daySchedule = {
      employee: employeeId,
      day: dayId,
      hours: newHours
    };
    this.saveEmployeeDaySchedule(daySchedule);
  }
  deleteHourRange(editedSchedule) {
    // let editedSchedule = this.state.editedSchedule;
    let employeeId = editedSchedule.employeeId;
    let dayId = editedSchedule.dayId;
    let hourNumber = editedSchedule.hourNumber;
    let weekId = editedSchedule.weekId;
    let schedules = this.state.schedules;
    let weekSchedule = schedules[weekId];
    let daySchedules = weekSchedule[dayId];
    let day = daySchedules[employeeId];
    let hours = day.hours;
    // let newHour = {
    //   start: editedSchedule.start,
    //   end: editedSchedule.end,
    //   number: hourNumber,
    //   workplace: editedSchedule.workplace
    // };
    let newHours = [];
    hours.map(_hour => {
      if (_hour.number !== hourNumber) newHours.push(_hour);
    });
    day.hours = newHours;
    daySchedules[employeeId] = day;
    weekSchedule[dayId] = daySchedules;
    schedules[weekId] = weekSchedule;
    this.setState({
      schedules: schedules,
      openEditSchedule: false,
      editedSchedule: null
    });
    let daySchedule = {
      employee: employeeId,
      day: dayId,
      hours: newHours
    };
    this.saveEmployeeDaySchedule(daySchedule);
  }
  handleEditScheduleCancel() {
    this.setState({
      openEditSchedule: false,
      editedSchedule: null
    });
  }
  validateEditSchedule() {
    return this.getDayHourRangeEditedSchedule() !== null;
  }
  render() {
    // console.log("this.state.schedules", this.state.schedules);
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <div>
          //     <h6 style={dashboardOrdersTitleStyle}>Evolución clientes</h6>
          //   <Line
          //     data={!this.state.customersChartReady? dashboardPanelChart.data : this.state.customersChart.data}
          //     options={!this.state.customersChartReady? dashboardPanelChart.options : this.state.customersChart.options}
          //   />
          //   </div>
          // }
        />
        <div className="content">
          <Modal
            title="Editar turno"
            open={this.state.openEditSchedule}
            onOk={this.handleEditScheduleOk}
            onCancel={this.handleEditScheduleCancel}
            okButtonProps={{
              disabled: !this.validateEditSchedule(),
            }}
            cancelButtonProps={{
              disabled: false,
            }}
          >
            <TimePicker.RangePicker
              onChange={(value) => {
                // console.log("cambio del picker range", value);
                this.setDayHourRangeEditedSchedule(value);
              }}
              status={this.getDayHourRangeEditedSchedule() ? null : "error"}
              format="HH:mm"
              value={this.getDayHourRangeEditedSchedule()}
              defaultOpenValue={dayjs("00:00", "HH:mm")}
              size="large"
            />
            <Select
              // mode="multiple"
              allowClear
              style={{
                width: "100%"
              }}
              loading={!this.state.myWorkplacesOptions}
              placeholder="Elige el lugar"
              value={this.getEditedScheduleWorkplace()}
              // defaultValue={['a10', 'c12']}
              onChange={value => this.setEditedScheduleWorkplace(value)}
              options={this.state.myWorkplacesOptions}
              suffixIcon={<i className="fa fa-building" />}
              size="large"
              disabled={this.state.isAssigningSchedule}
            />
          </Modal>
          <Row>
          </Row>
          <Row>
            {/* {this.createMyCompanyCard()} */}
            {/* {this.createMyEmployeesCard()} */}
            {this.createSchedulesCard()}
          </Row>
        </div>
      </div>
    );
  }
}

export default Schedule;



// WEBPACK FOOTER //
// ./src/views/Schedule/Schedule.jsx